import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {HttpClient, HttpEvent, HttpHeaders, HttpRequest} from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseFisofoService {

  private url:string;
  private headers: HttpHeaders = new HttpHeaders({
    'Access-Control-Allow-Origin': '*'
    , 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE'
    , 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,X-Access-Token,XKey,Authorization'
  });

  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  download=(year:string, month:string)=> {
    return this.http.get(`${this.url}/BaseFisofo/download?year=${year}&month=${month}`, {responseType: 'blob'});
  }

  getListBaseFisofoPaginated=(request:any)=> {
    return this.http.post(`${this.url}/BaseFisofo/getListBaseFisofoPaginated`, request)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  upload(file: File, userId:number, year:string, month:string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    const req = new HttpRequest('POST', `${this.url}/BaseFisofo/upload?userId=${userId}&year=${year}&month=${month}`, formData, {
      reportProgress: true,
      responseType: 'json',
      headers: this.headers
    });

    return this.http.request(req);
  }
}
